import { useMemo } from 'react';
import { Box, Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { Reaction } from '../../../../generated/graphql';

type CommunityPostCellProps = {
  reactions: Reaction[];
  onAddComment: () => void;
  hideAddComment?: boolean;
};

export const PostFooter = ({
  reactions,
  onAddComment,
  hideAddComment = false,
}: CommunityPostCellProps) => {
  const commentsCount = useMemo(() => {
    const comments = reactions.find(
      (reaction: Reaction) => reaction.type === 'Comment',
    );
    return comments?.count ?? 0;
  }, [reactions]);

  return (
    <Box className="flex flex-row justify-between items-center">
      <span
        style={{
          fontWeight: 800,
          fontSize: '0.6rem',
          lineHeight: '0.875rem',
          textTransform: 'uppercase',
        }}
      >
        {commentsCount === 1 ? '1 comment' : `${commentsCount} comments`}
      </span>
      {!hideAddComment && (
        <Button
          variant="text"
          onClick={onAddComment}
          sx={{
            display: 'flex',
            padding: '8px 16px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
            textTransform: 'none',
          }}
        >
          <FontAwesomeIcon
            icon={faPlus}
            style={{
              color: 'var(--sys-primary-P-80, #5F1ECC)',
              textAlign: 'center',
              fontFamily: '"Font Awesome 6 Pro"',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: 900,
              lineHeight: '18px',
            }}
          />
          <span
            style={{
              color: 'var(--sys-primary-P-80, #5F1ECC)',
              fontFamily: 'Visuelt, sans-serif',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '24px',
            }}
          >
            Comment
          </span>
        </Button>
      )}
    </Box>
  );
};
